<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a time picker
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span class="time-picker">
        <div v-if="!inline" class="row">
            <div class="col-sm-6">
                <select :name="hours_input" :value="hours_data" v-on:input="update_hours($event)" class="form-control form-control-sm">
                    <option v-for="hour in hours_list" :key="hour.value" :value="hour.value">{{hour.display}}</option>
                </select>
            </div>
            <div class="col-sm-6">
                <select :name="minutes_input" :value="minutes_data" v-on:input="update_minutes($event)" class="form-control form-control-sm">
                    <option v-for="minute in minutes_list" :key="minute.value" :value="minute.value">{{minute.display}}</option>
                </select>
            </div>
        </div>
        <span v-else class="d-flex">
            <div class="flex-full">
                <select :name="hours_input" :value="hours_data" v-on:input="update_hours($event)" class="form-control form-control-sm">
                    <option v-for="hour in hours_list" :key="hour.value" :value="hour.value">{{hour.display}}</option>
                </select>
            </div>
            <div class="flex-full">
                <select :name="minutes_input" :value="minutes_data" v-on:input="update_minutes($event)" class="form-control form-control-sm">
                    <option v-for="minute in minutes_list" :key="minute.value" :value="minute.value">{{minute.display}}</option>
                </select>
            </div>
        </span>

    </span>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object
            },
            //the default hours value
            hours: {
                default: '9'
            },
            //the default minutes value
            minutes: {
                default: '0'
            },
            //the name of the input
            start: {
                type: String,
                default: ''
            },
            //whether or not the input should be displayed inline
            inline: {
                type: Boolean,
                default: true
            }
        },
        mounted: function(){
            if(this.value !== undefined && this.value !== null){
                this.hours_data = this.value.hours !== undefined ? this.value.hours : this.hours_data;
                this.minutes_data = this.value.minutes !== undefined ? this.value.minutes : this.minutes_data;
                this.$emit('input', this.time_data);
            }
        },
        data() {
            return {
                //the current hours value
                hours_data: this.hours,
                //the current minutes value
                minutes_data: this.minutes,
                //the name of the input
                start_data: this.start
            };
        },
        computed: {
            /**
             * returns an numeric representation of the time selected e.g 17.5 would be 17:30
             * 
             * @return numeric the time
             */
            time: function() {return (parseInt(this.hours_data) + (parseInt(this.minutes_data)/60)).toFixed(2);},
            /**
             * returns the time in a struct
             * 
             * @return object the time
             */
            time_data: function() {return {hours: this.hours_data, minutes: this.minutes_data}},
            /**
             * returns the name of the hours input
             * 
             * @return String the name
             */
            hours_input: function () {return this.start_data + 'hours'},
            /**
             * returns the name of the minutes input
             * 
             * @return String the name
             */
            minutes_input: function () {return this.start_data + 'minutes'},
            /**
             * returns an array of hours
             * 
             * @return Array an array of hours
             */
            hours_list: function () {
                var arr = [];
                for(var $i=0; $i<24; $i++){
                    var $dis = $i;
                    if($i < 10){
                        $dis = '0' + $i;
                    }
                    arr.push({ value: $i, display: $dis});
                }
                return arr;
            },
            /**
             * returns an array of minutes
             * 
             * @return Array an array of minutes
             */
            minutes_list: function () {
                var arr = [];
                for(var $i=0; $i<60; $i++){
                    if($i == this.minutes_data || $i%15 == 0){
                        var $dis = $i;
                        if($i < 10){
                            $dis = '0' + $i;
                        }
                        arr.push({ value: $i, display: $dis});
                    }
                }
                return arr;
            }
        },
        methods: {
            getHours: function(){
                return this.hours_data;
            },
            getMinutes: function(){
                return this.minutes_data;
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_minutes: function (value) {
                var val = value;
                if(value.target !== undefined && value.target.value !== undefined){
                    val = value.target.value;
                }
                this.minutes_data = val;
                this.$emit('input', this.time_data);
                this.$emit('change', this.time_data);
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_hours: function (value) {
                var val = value;
                if(value.target !== undefined && value.target.value !== undefined){
                    val = value.target.value;
                }
                this.hours_data = val;
                this.$emit('input', this.time_data);
                this.$emit('change', this.time_data);
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_time: function (hours, minutes) {
                this.hours_data = hours;
                this.minutes_data = minutes;
                this.$emit('input', this.time_data);
                this.$emit('change', this.time_data);
            },
        }
    }
</script>
